import { Type } from "js-yaml";
class ParsedQuery {
  id;
  constructor(id) {
    this.id = id;
  }
}
const QueryTag = new Type("!query", {
  kind: "scalar",
  resolve: (data) => data !== null && typeof data === "string",
  construct: (data) => new ParsedQuery(data),
  instanceOf: ParsedQuery,
  represent: (data) => data.id
});
export {
  ParsedQuery,
  QueryTag
};
